import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4aac647a")

_pushScopeId("data-v-4aac647a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Payment method")
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Margin Available")
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("My Credit")
const _hoisted_6 = { class: "df-middle" }
const _hoisted_7 = { class: "credit-warn" }
const _hoisted_8 = { class: "credit-warn-c" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Radio = _resolveComponent("Radio")
  const _component_money = _resolveComponent("money")
  const _component_TheAsset = _resolveComponent("TheAsset")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Pic = _resolveComponent("Pic")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_t, {
      as: "p",
      path: "placeorder_10",
      class: "c-text f-nm f-bold mb-20"
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode("div", {
      class: ["d-f type", {'f-bold': !_ctx.useCoupon.value}],
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.useCash(true)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Radio, {
          name: "channel",
          value: false,
          modelValue: _ctx.useCoupon.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.useCoupon.value = $event))
        }, {
          default: _withId(() => [
            _createVNode(_component_t, {
              path: "placeorder_11",
              class: "ml-8"
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_TheAsset, null, {
        default: _withId(({freeMargin}) => [
          _createVNode(_component_money, {
            class: "df-middle",
            v: freeMargin
          }, null, 8, ["v"])
        ]),
        _: 1
      })
    ], 2),
    (!_ctx.isCommission)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["d-f mt-20 type", {'f-bold': _ctx.useCoupon.value}],
          style: {"position":"relative"},
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.useCash(false)))
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Radio, {
              name: "channel",
              value: true,
              modelValue: _ctx.useCoupon.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.useCoupon.value = $event))
            }, {
              default: _withId(() => [
                _createVNode(_component_t, {
                  path: "credit_2",
                  class: "ml-8"
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_TheAsset, null, {
            default: _withId(({freeMargin}) => [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_money, {
                  class: "df-middle",
                  v: freeMargin
                }, null, 8, ["v"]),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_Icon, {
                    name: "warn",
                    sm: "",
                    class: "ml-4 c-tip"
                  }),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_t, {
                      class: "credit-tip px-8 py-6 df-middle",
                      path: "credit_7",
                      args: {value: 10}
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode("div", {
            class: "credit-pop df-middle py-8 px-10",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCreditRuleDialog && _ctx.openCreditRuleDialog(...args)))
          }, [
            _createVNode(_component_Icon, {
              name: "warn",
              sm: "",
              class: "c-tip"
            }),
            _createVNode(_component_t, {
              class: "f-md c-white mx-10 credit-text",
              path: "credit_9"
            }),
            _createVNode(_component_Pic, {
              src: "trade/close2",
              width: "16",
              height: "16"
            })
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
})